import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount } from 'vue';

// const childValue = ref<string>(''); // Valor recibido del hijo

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleLayout',
  setup(__props) {

const footerRef = ref<HTMLElement | null>(null);
const footerHeight = ref<number>(0);

// const handleExpandedValue = (value: string): void => {
//   childValue.value = value;
// };

const checkHeight = () => {
  if (footerRef.value) {
    footerHeight.value = footerRef.value.offsetHeight;
  }
};

onMounted(() => {
  checkHeight();
  window.addEventListener("resize", checkHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkHeight);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _renderSlot(_ctx.$slots, "content", {}, () => [
      _cache[0] || (_cache[0] = _createElementVNode("p", null, "Oops some content is missing here...", -1))
    ])
  ]))
}
}

})